import React, { useState } from 'react';
import { Sun, MoonStars } from '@phosphor-icons/react';
import { getTheme, toggleTheme } from '../utils/theme';

// Bascule crème / sombre. Pendant la migration le défaut est sombre ;
// permet de prévisualiser le thème crème page par page.
export default function ThemeToggle({ compact = false }) {
  const [theme, setThemeState] = useState(getTheme());

  const basculer = () => setThemeState(toggleTheme());
  const versCreme = theme === 'dark';

  return (
    <button
      type="button"
      onClick={basculer}
      className="theme-toggle"
      title={versCreme ? 'Passer au thème crème' : 'Passer au thème sombre'}
      aria-label={versCreme ? 'Passer au thème crème' : 'Passer au thème sombre'}
    >
      {versCreme ? <Sun size={18} weight="bold" /> : <MoonStars size={18} weight="bold" />}
      {!compact && <span>{versCreme ? 'Crème' : 'Sombre'}</span>}
    </button>
  );
}
